import { createSvgComponent } from "../../icon/createSvgComponent";
import WarningTriangle from "@core/__generated__/icon/figma/warning-triangle.svg";
export default createSvgComponent(WarningTriangle);